var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95604 18.9586H5.16482V17.1878H14.8352V18.9586H16.044V14.2366C16.044 13.5873 15.8072 13.0315 15.3338 12.5692C14.8604 12.1068 14.2912 11.8756 13.6264 11.8756H9.39561V16.0073H5.16482V10.6951H3.95604V18.9586ZM7.28407 15.4171C7.70824 15.4171 8.06546 15.2741 8.35575 14.988C8.64606 14.702 8.79121 14.3519 8.79121 13.9377C8.79121 13.5235 8.64477 13.1746 8.35189 12.8911C8.05901 12.6076 7.7005 12.4659 7.27636 12.4659C6.85219 12.4659 6.49496 12.6089 6.20468 12.8949C5.91437 13.1809 5.76921 13.531 5.76921 13.9453C5.76921 14.3595 5.91565 14.7083 6.20854 14.9918C6.50142 15.2753 6.85993 15.4171 7.28407 15.4171ZM0 22.5V7.85124L10 0.5L20 7.85124V22.5H0ZM1.42857 21.1049H18.5714V8.5488L10 2.27076L1.42857 8.5488V21.1049Z",
    fill: "#717171"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.266d5b60e57fc421a5d30f00a4b58d88.svg";
export { ForwardRef as ReactComponent };